import { RouterProvider } from 'react-router-dom'
import { router } from '@/router'
import { navigateTo } from '@/utils/navigation'
import './App.scss'
import { STORAGE_KEYS } from './constants/storage'
import { useEffect, useRef } from 'react'
import { parsePathQuery } from './utils'
import useIncomeStore from './store/income'
import useGlobalStore from './store/global'
import useChannelStore from './store/channel'
import useUserStore from './store/user'
import { PAY_MODE } from './constants/payMode'

function App() {
  const isInitialized = useRef(false)
  useEffect(() => {
    if (isInitialized.current) {
      return
    }
      // 判断是否有auth参数
    const { query } = parsePathQuery(window.location.href)
      // 获取url上的productCode参数
    console.log(query)
    // 分期付款携带参数
    if (query.accessToken) {
      
      useIncomeStore.getState().setIncomeData({
        accessToken: query.accessToken,
        flowType: query.flowType,
        mobile: query.mobile,
        flowChannelCode: query.flowChannelCode,
        productCode: query.productCode,
        channelCode: query.channelCode,
        redirectUrl: query.redirectUrl,
        amt: query.amt,
        orderNo: query.orderNo,
      })
    }

    // // 赊购支付携带参数
    // if (query?.payMode && query?.payMode === PAY_MODE.CREDIT_SALE_PAY) {
    //   useSubCreditSaleStore.getState().setOriginQuery(query)
    // }
    isInitialized.current = true

    const urlParams = new URLSearchParams(window.location.search)

    const channelCode = urlParams.get(STORAGE_KEYS.CHANNEL_CODE)
    const adChannelCode = urlParams.get(STORAGE_KEYS.AD_CHANNEL_CODE)
    if (channelCode || adChannelCode) {
      localStorage.setItem(STORAGE_KEYS.CHANNEL_CODE, channelCode || adChannelCode || '')
      useChannelStore.getState().setChannelCode(channelCode || adChannelCode || '')
    }

    const token = urlParams.get(STORAGE_KEYS.TOKEN)
    if (token) {
      localStorage.setItem(STORAGE_KEYS.TOKEN, token)
      useUserStore.getState().setToken(token)
    }

    const cooperationType = urlParams.get(STORAGE_KEYS.CO_OPERATION_TYPE)
    if (cooperationType) {
      localStorage.setItem(STORAGE_KEYS.CO_OPERATION_TYPE, cooperationType)
      useGlobalStore.getState().setCoOperationType(cooperationType)
    }


    const whitePageList = [
      '/gqs-apply',
      '/gateway',
      '/codeFruit/home'
    ]
    const currentPath = window.location.pathname
    //联登方式
    if (token && channelCode && !whitePageList.includes(currentPath)) {
      navigateTo('/gqs-quota')
    }

    console.log('currentPath',currentPath)
    if (currentPath === '/gqs-quota') {
      if (token) {
        navigateTo('/gqs-quota')
      } else {
        navigateTo('/gqs-register')
      }
    }
  }, [])

  return <RouterProvider router={router} />
}

export default App
